import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const UserListModel = t.model('UserListModel', {
  email: t.string,
  merchantID: t.string,
  mid: t.string,
  role: t.string,
  createdAt: t.string,
  invitedAt: t.string,
  status: t.string,
  permissionId: t.array(t.number),
  phone: t.maybeNull(t.string),
});

const UsersModel = t
  .model('UsersModel', {
    list: t.array(UserListModel),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default UsersModel;
